import React from 'react';
import ReactDOM from 'react-dom';

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/prosto-one/400.css";
import "@fontsource/telex/400.css";
import "@fontsource/material-icons/400.css";

import "./localfonts.css";

import './css/all.css';
import './css/index.css';
import App from './App';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
